import React from 'react'

import img1 from "../../../assets/img/currency.png"
import img2 from "../../../assets/img/world.png"
import img3 from "../../../assets/img/jobs.png"

function DescriptionHome() {
  return (
  
    <section className="mt-2 flex justify-center items-center flex-col text-center md:text-left ">
    <h1 className="text-2xl md:text-3xl font-bold font-nunito text-white p-5 my-5">
    All the tools you need, all in one place.
    </h1>
    <div className="flex flex-col md:flex-row items-center justify-center space-y-[60px] md:space-y-0 md:space-x-20">

      <div className="md:w-1/5 flex flex-col justify-center items-center">
       <p className="font-nunito font-mixed text-white text-sm md:text-xl md:pl-2">
       <b>Engage with users</b> from around the world on hundreds of topics everyday.
       </p>
        
       <div className="mt-7 h-[130px] md:h-[200px] w-[300px] md:w-full rounded-xl">
        <img src={img2} className='h-full w-full' alt='world' />
       </div>
      </div>

      <div className="md:w-1/5 flex flex-col justify-center items-center">
       <p className="font-nunito font-mixed text-white text-sm md:text-xl md:pl-2">
       <b>Take control of your data</b>, and earn money with our comprehensive marketplace.
       </p>
       <div className="mt-7 h-[130px] md:h-[200px] w-[300px] md:w-full rounded-xl">
        <img src={img1} className='h-full w-full' alt='world' />
       </div>
      </div>

      <div className="md:w-1/5 flex flex-col justify-center items-center">
       <p className="font-nunito font-mixed text-white mb-3 text-sm md:text-xl md:pl-2">
       <b>Easily apply for jobs</b> by engaging in projects curated just for you.
       </p>
       <div className="mt-7 h-[130px] md:h-[200px] w-[300px] md:w-full rounded-xl">
        <img src={img3} className='h-full w-full' alt='world' />
       </div>
      </div>
      
    </div>

    <div className="flex flex-col justify-center items-center my-10">
        <p className="font-nunito font-bold text-white text-sm md:text-xl">Scroll down to learn more</p>
        <img
          src="/assets/scroll.svg"
          alt="scroll down icon"
          className="w-3 h-3 md:w-6 md:h-6 animate-bounce my-6"
        />
    </div>
   <div>

   </div>
  </section>
  )
}

export default DescriptionHome
